import { LogoTheme, Size } from '../../constants';
import { ThemePrimary, ThemeText } from '../../context/theme/ThemeConstantsUpdated';

export const NAVIGATION = (userPageUrl?: string) => [
  { name: 'Home', to: '/' },
  { name: 'Blog', to: '/blog' },
  { name: userPageUrl ? 'You' : 'Join', to: userPageUrl || '/join' },
];

export const COLOR_BUTTON_ANIMATION = {
  whileHover: { scale: 1.2 },
  whileTap: { scale: 0.9 },
  transition: { duration: 0.1, ease: 'easeIn' },
};

export function getNavbarSizeClasses(size?: Size): NavbarClasses {
  const transitionClasses = 'transition-[height,padding] duration-300 ease-in-out';

  switch (size) {
    case Size.none:
      return {
        navbarHeight: 'hidden',
        contentTopPosition: 'top-0',
        contentTopPadding: 'mt-0',
        contentHeight: 'h-[100vh]',
        themeDropdownHeight: 'max-h-[calc(100vh-70px)]',
      };
    case Size.sm:
      return {
        navbarHeight: 'h-[72px]',
        contentTopPosition: 'top-[72px]',
        contentTopPadding: 'mt-[72px]',
        contentHeight: 'h-[calc(100vh-72px)]',
        themeDropdownHeight: 'max-h-[calc(100vh-142px)]',
      };
    case Size.lg:
      return {
        navbarHeight: 'h-[108px]',
        contentTopPosition: 'top-[108px]',
        contentTopPadding: 'mt-[108px]',
        contentHeight: 'h-[calc(100vh-108px)]',
        themeDropdownHeight: 'max-h-[calc(100vh-178px)]',
      };
    case Size.md:
    default:
      return {
        navbarHeight: 'h-[88px]',
        contentTopPosition: 'top-[88px]',
        contentTopPadding: 'mt-[88px]',
        contentHeight: 'h-[calc(100vh-88px)]',
        themeDropdownHeight: 'max-h-[calc(100vh-158px)]',
      };
  }
}

export function getLogoSizeClasses(size?: Size): LogoSizeClasses {
  switch (size) {
    case Size.xs:
      return { iconSizeClasses: 'h-14 w-14' };
    case Size.sm:
      return { iconSizeClasses: 'h-16 w-16' };
    case Size.lg:
      return { iconSizeClasses: 'h-32 w-32' };
    case Size.xl:
      return { iconSizeClasses: 'h-48 w-48' };
    case Size.md:
    default:
      return { iconSizeClasses: 'h-20 w-20' };
  }
}

export function getLogoStyleClasses(theme: LogoTheme): LogoStyleClasses {
  const { primaryText, primaryTextIntense, primaryTextMuted } = ThemePrimary;
  const { mainText, mainTextInverted } = ThemeText;

  switch (theme) {
    case LogoTheme.inverted:
      return {
        primaryTextColorClass: mainText,
        mainTextColorClass: mainTextInverted,
      };
    case LogoTheme.intense:
      return {
        primaryTextColorClass: primaryTextIntense,
        mainTextColorClass: mainTextInverted,
      };
    case LogoTheme.muted:
      return {
        primaryTextColorClass: primaryTextMuted,
        mainTextColorClass: mainTextInverted,
      };
    case LogoTheme.light:
      return {
        primaryTextColorClass: 'text-white',
        mainTextColorClass: primaryText,
      };
    case LogoTheme.lightColorless:
      return {
        primaryTextColorClass: 'text-white',
        mainTextColorClass: 'text-black',
      };
    case LogoTheme.dark:
      return {
        primaryTextColorClass: 'text-black',
        mainTextColorClass: primaryText,
      };
    case LogoTheme.darkColorless:
      return {
        primaryTextColorClass: 'text-black',
        mainTextColorClass: 'text-white',
      };
    case LogoTheme.primaryLight:
      return {
        primaryTextColorClass: primaryText,
        mainTextColorClass: 'text-white',
      };
    case LogoTheme.secondary:
      return {
        primaryTextColorClass: 'text-primary-900',
        mainTextColorClass: primaryText,
      };
    case LogoTheme.primary:
    default:
      return {
        primaryTextColorClass: primaryText,
        mainTextColorClass: 'text-white',
      };
  }
}

export type NavbarClasses = {
  navbarHeight: string;
  contentTopPosition: string;
  contentHeight: string;
  contentTopPadding: string;
  themeDropdownHeight: string;
};

type LogoSizeClasses = {
  iconSizeClasses: string;
};

type LogoStyleClasses = {
  primaryTextColorClass: string;
  mainTextColorClass: string;
};
